import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { Typography } from '@mui/material'
import { useAuthContext } from 'App/Auth'
import useStyle from 'shared/hooks/useStyle'

import ROUTE_KEYS from 'shared/utils/routeKeys'
import getGlobalAssetUrl from 'shared/utils/getGlobalAssetUrl'

import Breadcrumbs from './Breadcrumbs'
import styles from './Header.style'

type Props = {
    onClickMainMenu?: () => void
}

const Header = ({ onClickMainMenu }: Readonly<Props>) => {
    const classes = useStyle(styles)
    const navigate = useNavigate()
    const { logout } = useAuthContext()

    const handleLogoutClick = useCallback(() => {
        logout()
    }, [logout])

    const navigateToMainDashboard = useCallback(() => {
        if (onClickMainMenu) { onClickMainMenu() }
        navigate(ROUTE_KEYS.MAIN)
    }, [
        navigate,
        onClickMainMenu,
    ])

    return (
        <div css={classes.wrapper}>
            <button
                type="button"
                css={classes.logout}
                onClick={handleLogoutClick}
            >
                <img
                    src={getGlobalAssetUrl('icons/logout.svg')}
                    alt="logout"
                />
            </button>
            <div css={[
                classes.breadCrumbs,
                classes.titleHeader,
            ]}
            >
                <Breadcrumbs />
            </div>
            <div
                css={classes.logoContainer}
                onClick={navigateToMainDashboard}
                aria-hidden="true"
            >
                <Typography
                    variant="h1"
                    css={classes.titleHeader}
                >
                    SkyCenter
                </Typography>
                <div
                    css={classes.logo}
                >
                    <img
                        data-testid="logo"
                        alt="logo"
                        src={getGlobalAssetUrl('skycenter/logo.png')}
                    />
                </div>
            </div>
        </div>
    )
}

export default Header
